// Un código en MAYÚSCULAS_CON_GUIONES parte en sus segmentos: la celda angosta corta en el `_`
// y no a la mitad de una palabra. Lo comparten la bitácora y la ficha.
import { Fragment } from 'react';

export function BreakableCode({ value }: { value: string }) {
    return (
        <>
            {value.split('_').map((segment, index) => (
                <Fragment key={`${segment}-${String(index)}`}>
                    {index > 0 ? (
                        <>
                            {'_'}
                            <wbr />
                        </>
                    ) : null}
                    {segment}
                </Fragment>
            ))}
        </>
    );
}
